<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                A2P Registration
            </h2>
        </template>

        <div>
            <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8 shadow sm:rounded-md bg-white">
                <template v-if="$page.props.auth.user.organization.a2p_verified">
                    <h2 class="text-xl font-bold">
                        <font-awesome-icon
                            class="text-green-500"
                            :icon="['far', 'check-circle']"

                        ></font-awesome-icon>
                        You're Verified!</h2>
                        <br />
                    Congrats, you're registered with wireless carriers!
                </template>
                <template v-else-if="!$page.props.auth.user.organization.a2p_submitted">
                    Hmm, it doesn't seem like we've received your A2P application, or there was a problem processing it. <br />
                </template>
                <template v-else>
                    <h2 class="text-xl font-bold">Your A2P application is being processed</h2>
                    <div class="border-2 border-orange-400 bg-orange-100 p-4 rounded-lg mb-4 mt-4">
                        We will email you as soon as there is an update to your verification request from our providers. Verification requests are currently taking approximately {{ $page.props.approval_time_wording }} to process.
                    </div>
                </template>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";

export default {
    name: 'A2P-Status',
    props: [""],
    components: {
        AppLayout,
    },
    data() {
        return {

        }
    },
    methods: {


    }
};
</script>
